import { render, staticRenderFns } from "./ComfirmServeWindow.vue?vue&type=template&id=3c14d906&scoped=true&"
import script from "./ComfirmServeWindow.vue?vue&type=script&lang=js&"
export * from "./ComfirmServeWindow.vue?vue&type=script&lang=js&"
import style0 from "./ComfirmServeWindow.vue?vue&type=style&index=0&id=3c14d906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c14d906",
  null
  
)

export default component.exports